export const GET_LIST_GAME_CHANGER_OUTPUT_FILES_REQUEST =
  'GET_LIST_GAME_CHANGER_OUTPUT_FILES_REQUEST';
export const GET_LIST_GAME_CHANGER_OUTPUT_FILES_SUCCESS =
  'GET_LIST_GAME_CHANGER_OUTPUT_FILES_SUCCESS';
export const GET_LIST_GAME_CHANGER_OUTPUT_FILES_FAILURE =
  'GET_LIST_GAME_CHANGER_OUTPUT_FILES_FAILURE';

export const GET_AMAZON_CENTRAL_TRANSACTIONS_REQUEST = 'GET_AMAZON_CENTRAL_TRANSACTIONS_REQUEST';
export const GET_AMAZON_CENTRAL_TRANSACTIONS_SUCCESS = 'GET_AMAZON_CENTRAL_TRANSACTIONS_SUCCESS';
export const GET_AMAZON_CENTRAL_TRANSACTIONS_FAILURE = 'GET_AMAZON_CENTRAL_TRANSACTIONS_FAILURE';

export const GET_AMAZON_SELLER_CENTRAL_REQUEST = 'GET_AMAZON_SELLER_CENTRAL_REQUEST';
export const GET_AMAZON_SELLER_CENTRAL_SUCCESS = 'GET_AMAZON_SELLER_CENTRAL_SUCCESS';
export const GET_AMAZON_SELLER_CENTRAL_FAILURE = 'GET_AMAZON_SELLER_CENTRAL_FAILURE';

export const DOWNLOAD_GAME_CHANGER_FILE = 'DOWNLOAD_GAME_CHANGER_FILE';
export const DOWNLOAD_GAME_CHANGER_OUTPUT_FILE = 'DOWNLOAD_GAME_CHANGER_OUTPUT_FILE';

export const DELETE_GAME_CHANGER_OUTPUT_FILE_REQUEST = 'DELETE_GAME_CHANGER_OUTPUT_FILE_REQUEST';
export const DELETE_GAME_CHANGER_OUTPUT_FILE_SUCCESS = 'DELETE_GAME_CHANGER_OUTPUT_FILE_SUCCESS';
export const DELETE_GAME_CHANGER_OUTPUT_FILE_FAILURE = 'DELETE_GAME_CHANGER_OUTPUT_FILE_FAILURE';

export const RUN_GAME_CHANGER_REQUEST = 'RUN_GAME_CHANGER_REQUEST';
export const RUN_GAME_CHANGER_SUCCESS = 'RUN_GAME_CHANGER_SUCCESS';
export const RUN_GAME_CHANGER_FAILURE = 'RUN_GAME_CHANGER_FAILURE';

export const GET_GAME_CHANGER_OUTPUT_REQUEST = 'GET_GAME_CHANGER_OUTPUT_REQUEST';
export const GET_GAME_CHANGER_OUTPUT_SUCCESS = 'GET_GAME_CHANGER_OUTPUT_SUCCESS';
export const GET_GAME_CHANGER_OUTPUT_FAILURE = 'GET_GAME_CHANGER_OUTPUT_FAILURE';

export const POST_GAME_CHANGER_OUTPUT_FILES_REQUEST = 'POST_GAME_CHANGER_OUTPUT_FILES_REQUEST';
export const POST_GAME_CHANGER_OUTPUT_FILES_SUCCESS = 'POST_GAME_CHANGER_OUTPUT_FILES_SUCCESS';
export const POST_GAME_CHANGER_OUTPUT_FILES_FAILURE = 'POST_GAME_CHANGER_OUTPUT_FILES_FAILURE';

export const GAME_CHANGER_OUTPUT_FILE_IDS_REQUEST = 'GAME_CHANGER_OUTPUT_FILE_IDS_REQUEST';
export const GAME_CHANGER_OUTPUT_FILE_IDS_SUCCESS = 'GAME_CHANGER_OUTPUT_FILE_IDS_SUCCESS';
export const GAME_CHANGER_OUTPUT_FILE_IDS_FAILURE = 'GAME_CHANGER_OUTPUT_FILE_IDS_FAILURE';

export const DELETE_OUTPUT_FILE_REQUEST = 'DELETE_OUTPUT_FILE_REQUEST';
export const DELETE_OUTPUT_FILE_SUCCESS = 'DELETE_OUTPUT_FILE_SUCCESS';
export const DELETE_OUTPUT_FILE_FAILURE = 'DELETE_OUTPUT_FILE_FAILURE';

export const CLEAR_GAME_CHANGER_FILES = 'CLEAR_GAME_CHANGER_FILES';
